import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useData } from '@hooks/useData';

const ENDPOINT_URL = '/usr-users-geolocation';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type RegisterUserLocationsInput = paths[url]['post']['requestBody']['content']['application/json'];
export type RegisterUserLocationsResponse = paths[url]['post']['responses']['201']['content']['application/json'];

/**
 * Requests endpoint to register user's locations.
 */
export const useRegisterUserLocations = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setLastUserLocationLogged } = useData();

    const request = async (props: RegisterUserLocationsInput) => {
        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(props),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: RegisterUserLocationsResponse = await response.json();
            
            setLastUserLocationLogged(data.data?.created_at ? {
                latitude: data.data?.latitude,
                longitude: data.data?.longitude,
                type: data.data?.type,
                createdAt: new Date(data.data?.created_at).getTime()
            } : null);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        }
    };

    return { request };
};
